import React, { useEffect, useState } from 'react';
import { ProofItem } from '../types';
import { getProofs } from '../services/firebase';
import { Shield, ExternalLink, Loader2 } from 'lucide-react';

const ProofBoard: React.FC = () => {
  const [proofs, setProofs] = useState<ProofItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProofs = async () => {
      const data = await getProofs();
      setProofs(data);
      setLoading(false);
    };
    fetchProofs();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px] text-christmas-gold">
        <Loader2 className="animate-spin w-10 h-10 mb-4" />
        <p>Loading chain data...</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-4xl mx-auto px-4 pb-20">
      <div className="grid gap-6">
        {proofs.map((proof) => (
          <div 
            key={proof.id}
            className="bg-zinc-900/80 border border-zinc-700 rounded-2xl p-6 flex flex-col md:flex-row gap-6 hover:border-christmas-gold/50 transition-colors duration-300"
          >
            {/* Image Section */}
            {proof.imageUrl && (
              <div className="w-full md:w-1/3 h-48 md:h-auto rounded-xl overflow-hidden border border-zinc-800 shrink-0">
                <img 
                  src={proof.imageUrl} 
                  alt={proof.title}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
            )}

            {/* Content Section */}
            <div className="flex flex-col justify-between flex-grow">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <Shield size={18} className="text-christmas-green" />
                  <span className="text-xs text-christmas-green font-bold tracking-wider uppercase">Verified</span>
                  <span className="text-zinc-500 text-xs ml-auto">{proof.date}</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{proof.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm">{proof.description}</p>
              </div>
              
              <div className="mt-4 pt-4 border-t border-zinc-800 flex justify-end">
                <button className="flex items-center gap-2 text-sm text-christmas-gold hover:text-white transition-colors">
                  View Transaction <ExternalLink size={14} />
                </button>
              </div>
            </div>
          </div>
        ))}
        
        {proofs.length === 0 && (
            <div className="text-center py-20 bg-zinc-900/50 rounded-2xl border border-dashed border-zinc-700">
                <p className="text-gray-500">No proofs uploaded yet.</p>
            </div>
        )}
      </div>
    </div>
  );
};

export default ProofBoard;